import { AmpPropTag, IAmpPropsTag } from '../typings/amp';

export const getAmpTag = (ampProps?: Array<IAmpPropsTag>, tag?: AmpPropTag): IAmpPropsTag | undefined =>
  ampProps?.find((item: IAmpPropsTag) => item.tag === tag);

export const isAmp = (ampProps?: Array<IAmpPropsTag>) => !!ampProps;
